<template>
  <div>
    <div class="card top-draft">
      <div class="">
        <!-- <div class="col-lg-12 mg-top-1">
          <b-button variant="primary" @click="toCreate()" v-if="power['添加']">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div> -->

        <div class="col-lg-12 list-header pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.name"
              placeholder="请输入搜索内容"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <b-button
            class="btn-sm"
            variant="primary"
            @click="toCreate()"
            v-if="power['添加']"
          >
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive" v-loading="tableLoading">
            <table
              class="table table-nowrap table-centered table-striped align-middle"
            >
              <thead>
                <tr>
                  <!-- <th scope="col" style="width: 70px;">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th> -->
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col" class="w-300">名称</th>
                  <th scope="col">更新日期</th>
                  <th scope="col">创建时间</th>
                  <th scope="col"><span class="px-2">操作</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <!-- <td>
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td> -->
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">{{ item.name }}</td>
                  <td>{{ item.updatedAt || "--" }}</td>
                  <td>{{ item.createdAt || "--" }}</td>
                  <td>
                    <button
                      v-if="power['编辑']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item)"
                    >
                      编辑
                    </button>
                    <span v-if="item.id != 1">
                      <button
                        v-if="power['移除']"
                        type="button"
                        class="btn-sm btn btn-danger"
                        @click="remove(item)"
                      >
                        移除
                      </button>
                    </span>

                    <!-- <ul class="list-inline font-size-20 contact-links mb-0">
                      <li class="list-inline-item px-2" @click="toDetail(item)">
                        <a v-b-tooltip.hover title="编辑">
                          <i class="bx bxs-edit"></i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2" @click="remove(item)">
                        <a v-b-tooltip.hover title="移除">
                          <i class="bx bx-trash"></i>
                        </a>
                      </li>
                    </ul> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!items || !items[0]" class="xb-table-noData">
              <span v-if="!tableLoading && !items[0]">暂无数据</span>
            </div>
          </div>
          <pagination
            :total="pageTotal"
            :pageSize="pageParams.pageSize"
            :page.sync="pageParams.page"
            @pageCallback="pageCallback"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import roles from "@/server/api/roles";
import { changeList } from "@/util/fun.js";
import { addCache, updateCache } from "@/util/localAche.js";

/**
 * Contacts-list component
 */
export default {
  data() {
    return {
      power: "",
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        name: "",
        type: 2,
        mediaId: JSON.parse(localStorage.chosedMedia).id,
      },
      items: [],
      tableLoading: true,
      pageTotal: 0,
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    if (["/mediaRoleDetail"].indexOf(from.path) == -1) {
      updateCache("roles-list", { list: "" });
      addCache("roles-edit");
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (["/mediaRoleDetail"].indexOf(to.path) == -1) {
      updateCache("roles-list", { list: "" });
      addCache("roles-edit");
    }
    next();
  },
  created() {
    this.power = this.utils.currentPower("创作平台-角色管理");
    let obj = this.getCache("roles-list");
    if (obj && obj.list && obj.list[0]) {
      this.pageParams = obj.pageParams;
      this.items = obj.list;
      this.pageTotal = obj.pageTotal;
      obj = this.getCache("roles-edit");
      this.addCache("roles-edit");
      if (obj && obj.changed) {
        this.getList(false);
      }
    } else {
      this.addCache("roles-edit");
      this.getList();
    }
  },

  beforeDestroy() {
    this.addCache("roles-list", {
      list: this.items,
      pageTotal: this.pageTotal,
      pageParams: this.pageParams,
    });
  },

  methods: {
    //获取列表数据
    getList(showLoading) {
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      let params = this.utils.getQuery(this.pageParams);
      roles.list(params).then((resp) => {
        if (resp.code == 0) {
          this.tableLoading = false;
          if (resp.data.items) {
            this.items = resp.data.items;
            this.pageTotal = resp.data.total;
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "mediaRoleDetail",
        query: { mediaId: this.pageParams.mediaId },
      });
    },

    //去编辑
    toDetail(item, allModify) {
      if (allModify) {
        this.$router.push({
          name: "mediaRoleDetail",
          query: { id: item.id, allModify: true },
        });
      } else {
        this.$router.push({
          name: "mediaRoleDetail",
          query: { id: item.id },
        });
      }
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.name = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    remove(item) {
      Swal.fire({
        title: "确定移除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "移除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.id = item.id;
          roles.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList();
              this.pageTotal -= 1;
              this.items = changeList("delete", this.items, [item.id], "id");
            } else {
              Vue.swal({
                icon: "error",
                title: resp.msg,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },
  },
};
</script>
